import React from 'react';
import { UseFormSetError, UseFormSetValue, FieldValues, Path, PathValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PROJECT_NAME_MAX_LENGTH = 255;

type UseProjectNameValidationParams<T extends FieldValues> = {
  fieldName: Path<T>;
  setValue: UseFormSetValue<T>;
  setError: UseFormSetError<T>;
};

export const useProjectNameValidation = <T extends FieldValues>({
  fieldName,
  setValue,
  setError,
}: UseProjectNameValidationParams<T>) => {
  const { t } = useTranslation();

  const maxLengthMessage = `${t('saveProjectDialog.maxLengthProjectName')}`;

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > PROJECT_NAME_MAX_LENGTH) {
      const truncated = e.target.value.slice(0, PROJECT_NAME_MAX_LENGTH);
      setValue(fieldName, truncated as PathValue<T, Path<T>>);
      setError(fieldName, {
        type: 'maxLength',
        message: maxLengthMessage,
      });
    }
  };

  return { handleNameChange, maxLengthMessage, PROJECT_NAME_MAX_LENGTH };
};
